import Components from "../components";

// This augments our Actions selector by
//
// * Injecting the dropdown selection into any hidden fields
// * Updates styles for selected / unselected Actions
// * Disables form submission for any enter key presses
class ActionSelection extends Components.Base {
  initialize() {
    this.$dropdownInput = this.$el.find(".dropdown-component__search input");
  }

  bind() {
    this.on("submit", "form", (e) => this.checkForDelete(e));
    this.on("click", "[data-action-choice]", (e) => this.dropdownClick(e));
    this.on("change", ".action-checkbox", (e) => this.actionCheckUpdate(e));
    this.$dropdownInput.on("keydown.dropdown-with-search", (e) =>
      this.searchKey(e),
    );
    this.checkInitialStatus();
  }

  checkForDelete(e) {
    const formData = $(e.target).serializeArray();
    const isDeleting = formData.some(
      ({ name, value }) =>
        name === "batch_actions[selected_actions][]" && value === "delete",
    );
    if (!isDeleting) return;

    if (
      window.confirm(
        "You are deleting faults. Are you sure? This cannot be undone!",
      )
    ) {
      // Uncheck everything but delete
      $(e.target)
        .find('input[type="checkbox"]:not(#delete)')
        .prop("checked", false);
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  searchKey(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  // Style switching effect from checkbox selection
  actionCheckUpdate(e) {
    const $root = $(e.target).parents(".form-row").first();

    if (e.target.checked) {
      if ($root.attr("name") === "delete") {
        $root.parents(".c-action-selection").addClass("will-delete");
      } else if ($root.attr("name") === "merge") {
        $root.parents(".c-action-selection").addClass("will-merge");
      }

      $root.removeClass("inactive");
    } else {
      if ($root.attr("name") === "delete") {
        $root.parents(".c-action-selection").removeClass("will-delete");
      } else if ($root.attr("name") === "merge") {
        $root.parents(".c-action-selection").removeClass("will-merge");
      }

      $root.addClass("inactive");
    }
  }

  // If the form reloads, this will persist some form state.
  checkInitialStatus() {
    $(".action-checkbox", this.$el).each((index, el) => {
      const root = $(el).parents(".form-row").first();

      if (el.checked) {
        if (root.attr("name") === "delete") {
          root.parents(".c-action-selection").addClass("will-delete");
        } else if (root.attr("name") === "merge") {
          root.parents(".c-action-selection").addClass("will-merge");
        }

        root.removeClass("inactive");
      }
    });
  }

  // Generic dropdown updater
  dropdownClick(e) {
    const $sel = $(e.target).closest("[data-action-choice]");
    const $root = $sel.closest(".form-row");
    Array.from($sel[0].attributes).forEach((k) => {
      const matches = k.name.match(/data-value-(.*)/);
      if (matches) {
        $root.find(`[data-field="${matches[1]}"]`).attr("value", k.value);
      }
    });
    $root.find(".display").text($sel.data("display"));
  }
}

Components.collection.register({
  selector: ".c-action-selection",
  klass: ActionSelection,
});
